<template>
  <el-container class="NotificationsList">
    <el-header class="NotificationsList-header" height="40px">
      <h3>{{ $t("layouts.notifications") }}</h3>
      <el-button
        class="NotificationsList-unreadAll"
        :disabled="!unread || !unread.length"
        icon="check"
        size="mini"
        @click="setAllNotificationsRead"
      >
      </el-button>
    </el-header>
    <el-main class="NotificationsList-notifications">
      <p class="mb-4" v-if="!list || !list.length">
        {{ $t("layouts.noNotification") }}
      </p>
      <el-table v-else :data="list" :show-header="false">
        <el-table-column>
          <template v-slot="{ row: notification }">
            <div class="NotificationsList-message">
              <p class="mb-0">
                {{ notification.data.message }}
              </p>

              <el-button
                v-if="!notification.read"
                class="NotificationsList-unread"
                icon="check"
                size="mini"
                type="success"
                @click="setNotificationRead(notification.data)"
              ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import { getUserNotifications } from '@/services/notifications'

export default {
  name: 'NotificationsList',
  props: {
    orientation: { type: String, default: 'top' }
  },
  computed: {
    ...mapState('notifications', ['list']),
    ...mapGetters('notifications', ['unread'])
  },
  methods: {
    ...mapActions('notifications', [
      'addNotifications',
      'setNotificationRead',
      'setAllNotificationsRead'
    ])
  },
  async created () {
    const notifications = await getUserNotifications()
    this.addNotifications(notifications)
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.NotificationsList {
  max-height: 80vh;
  overflow: visible;

  &-unreadAll {
    position: absolute;
    right: 10px;
    top: map-get($spacers, 3);
  }

  &-unread {
    @extend .ml-2;
  }

  &-message {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &-notifications {
    margin: 0 map-get($spacers, 4) * -1 map-get($spacers, 4) * -1
      map-get($spacers, 4) * -1 !important;
  }

  @include media-breakpoint-down(sm) {
    max-height: 50vh;
  }
}
</style>
